import { z } from "zod";

export const RecommendationItemSchema = z.object({
    source: z.enum(["catalog", "web"]),
    id: z.string(),
    lmtId: z.string().nullable(),
    name: z.string(),
    description: z.string().nullable(),
    score: z.number().min(1).max(10),
    rationale: z.object({
        whyRelevant: z.string().nullable(),
        potentialRisks: z.string().nullable(),
        bestUseCase: z.string().nullable(),
    }),
    address: z.string().nullable().optional(),
    city: z.string().nullable(),
    country: z.string().nullable(),
    googleUrl: z.string().nullable().optional(),
});

export type RecommendationItem = z.infer<typeof RecommendationItemSchema>;
